import React from 'react';
import KurtWaiting from './KurtWaiting';

function VideoView({
  modVideoRef,
  studentSelfVideoRef,
  modStreamAvailable,
  modVideoMuted,
  audioJoined
}) {
  return (
    <div className="videoViewContainer">
      {/* Hintergrund wie Quiz-Fenster */}
      <div className="fixedBackgroundStyle"></div>

      {/* Klugeschule-Marke oben links (wie im Quiz-Cockpit) */}
      <div className="ksBrandBadge">
        <span className="ksBrandDot"><img src="/images/klugeschule-logo.png" alt="" /></span>
        Kluge&nbsp;Schule
      </div>

      {/* Großer Video-Stream des Moderators */}
      <div className="videoViewMainStream">
        <video
          ref={modVideoRef}
          className="videoViewMainVideo"
          autoPlay
          playsInline
          muted={false} // Audio ist aktiviert
          onLoadedMetadata={() => {
            console.log("📹 Video-View: Moderator-Video Metadaten geladen");
          }}
          onError={(e) => {
            console.error("❌ Video-View: Moderator-Video Fehler:", e);
          }}
        />
        {(!modStreamAvailable || modVideoMuted) && <KurtWaiting />}
      </div>

      {/* Kleine eigene Kamera unten links */}
      <div className="videoViewSelfContainer">
        <video
          ref={studentSelfVideoRef}
          className="videoViewSelfVideo"
          autoPlay
          playsInline
          muted
        />
        <div className="videoViewSelfLabel">Du</div>
      </div>

      {/* Audio-Element für Moderator (versteckt) */}
      <audio id="modAudio" autoPlay style={{ display: "none" }} />
    </div>
  );
}

export default VideoView;